import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { CategoryDetailResponse } from "../../../../graphql/types"
import type { UnmatchedOrderItemNamesResponse } from "./detail/request"
import {
    CategoryAddRequestedPayload,
    CategoryUpdateRequestedPayload,
    ProductAddRequestedPayload,
    ProductUpdateRequestedPayload,
} from "../../../../events/Category/types"

export const CATEGORY_CREATED = "category/created"
export const categoryCreated = (data: CategoryAddRequestedPayload) => ({
    type: CATEGORY_CREATED,
    payload: {
        data: data,
    },
})

export const CATEGORY_UPDATED = "category/updated"
export const categoryUpdated = (data: CategoryUpdateRequestedPayload) => ({
    type: CATEGORY_UPDATED,
    payload: {
        data: data,
    },
})

export const CATEGORY_DELETED = "category/deleted"
export const categoryDeleted = (id: string, parentId: Maybe<string>) => ({
    type: CATEGORY_DELETED,
    payload: {
        categoryId: id,
        parentId: parentId,
    },
})

export const PRODUCT_CREATED = "product/created"
export const productCreated = (data: ProductAddRequestedPayload) => ({
    type: PRODUCT_CREATED,
    payload: {
        data: data,
    },
})

export const PRODUCT_UPDATED = "product/updated"
export const productUpdated = (data: ProductUpdateRequestedPayload) => ({
    type: PRODUCT_UPDATED,
    payload: {
        data: data,
    },
})

export const PRODUCT_DELETED = "product/deleted"
export const productDeleted = (id: string, parentId: Maybe<string>) => ({
    type: PRODUCT_DELETED,
    payload: {
        categoryId: id,
        parentId: parentId,
    },
})

export const PRODUCTS_AND_CATEGORIES_DELETED = "productsAndCategories/deleted"
export const productsAndCategoriesDeleted = (ids: string[]) => ({
    type: PRODUCTS_AND_CATEGORIES_DELETED,
    payload: {
        productIds: ids,
    },
})

export const CATEGORY_TABLE_ITEM_CLICKED = "CATEGORY_TABLE_ITEM_CLICKED"
export const categoryTableItemClicked = (id: string) => {
    return {
        type: CATEGORY_TABLE_ITEM_CLICKED,
        payload: {
            id: id,
        },
    }
}

export const FETCH_CATEGORY_DETAIL_REQUESTED = "FETCH_CATEGORY_DETAIL_REQUESTED"
export const fetchCategoryDetailRequested = () => {
    return {
        type: FETCH_CATEGORY_DETAIL_REQUESTED,
    }
}

export const FETCH_CATEGORY_DETAIL_SUCCESS = "FETCH_CATEGORY_DETAIL_SUCCESS"

export const fetchCategoryDetailSuccess = (data: CategoryDetailResponse) => {
    return {
        type: FETCH_CATEGORY_DETAIL_SUCCESS,
        payload: {
            data: data,
        },
    }
}

export const PRODUCT_DUPLICATE_SUCCESS = "product/duplicate/success"

export const productDuplicateSuccess = (data: ProductAddRequestedPayload) => ({
    type: PRODUCT_DUPLICATE_SUCCESS,
    payload: {
        data: data,
    },
})

export const CATEGORY_SEARCH_CLICKED = "category/search/clicked"

export const categorySearchClicked = (searchValue: Maybe<string>) => ({
    type: CATEGORY_SEARCH_CLICKED,
    payload: {
        searchValue: searchValue,
    },
})

export const FETCH_UNMATCHED_ORDER_ITEM_NAMES_REQUESTED = "FETCH_UNMATCHED_ORDER_ITEM_NAMES_REQUESTED"

export const fetchUnmatchedOrderItemNamesRequested = () => {
    return {
        type: FETCH_UNMATCHED_ORDER_ITEM_NAMES_REQUESTED,
    }
}

export const FETCH_UNMATCHED_ORDER_ITEM_NAMES_SUCCESS = "FETCH_UNMATCHED_ORDER_ITEM_NAMES_SUCCESS"

export const fetchUnmatchedOrderItemNamesSuccess = (data: UnmatchedOrderItemNamesResponse) => {
    return {
        type: FETCH_UNMATCHED_ORDER_ITEM_NAMES_SUCCESS,
        payload: {
            data: data,
        },
    }
}
